module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_22.26e09daa.png";